/* LightSeek collection page — mirrors frontend/web products list interactions */
(function () {
  'use strict';

  var cfg = window.LS_COLLECTION || {};
  var root = document.querySelector('.pl-page');
  if (!root) return;

  var STORAGE_KEY = 'lightseek-inquiry-products';
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  function readInquiry() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function addToInquiry(item) {
    var list = readInquiry();
    var exists = list.some(function (p) { return String(p.id) === String(item.id); });
    if (!exists) {
      var entry = {
        id: String(item.id),
        name: item.name,
        model: item.model,
        image: item.image,
        url: item.url,
        quantity: 1
      };
      list.push(entry);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }
    window.location.href = cfg.inquiryUrl || '/pages/inquiry';
  }

  /* ---------------- filter dropdowns ---------------- */
  function closeAllDropdowns() {
    $$('.fb-dropdown').forEach(function (dd) { dd.hidden = true; });
    $$('.fb-box').forEach(function (box) {
      box.classList.remove('fb-box-open');
      box.setAttribute('aria-expanded', 'false');
    });
    $$('.fb-item').forEach(function (item) { item.classList.remove('fb-item-open'); });
  }

  $$('.fb-box').forEach(function (box) {
    box.addEventListener('click', function (e) {
      e.stopPropagation();
      var item = box.closest('.fb-item');
      var dd = item ? $('.fb-dropdown', item) : null;
      var wasOpen = dd && !dd.hidden;
      closeAllDropdowns();
      if (!wasOpen && dd) {
        dd.hidden = false;
        box.classList.add('fb-box-open');
        box.setAttribute('aria-expanded', 'true');
        item.classList.add('fb-item-open');
      }
    });
  });

  document.addEventListener('click', closeAllDropdowns);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  $$('.fb-option').forEach(function (opt) {
    opt.addEventListener('click', function (e) {
      e.stopPropagation();
      if (opt.classList.contains('fb-option-empty')) return;

      var href = opt.getAttribute('data-href');
      if (href) { window.location.href = href; return; }

      var item = opt.closest('.fb-item');
      var param = item && item.getAttribute('data-param');
      if (!param) return;
      var value = opt.getAttribute('data-value') || '';
      var url = new URL(window.location.href);
      if (!value || url.searchParams.get(param) === value) {
        url.searchParams.delete(param);
      } else {
        url.searchParams.set(param, value);
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  var moreToggle = $('[data-fb-toggle]');
  if (moreToggle) {
    moreToggle.addEventListener('click', function () {
      var row = moreToggle.closest('.fb-row');
      if (!row) return;
      var expanded = row.classList.toggle('fb-expanded');
      $$('[data-fb-extra]', row).forEach(function (item) { item.hidden = !expanded; });
      var label = $('[data-fb-toggle-text]', moreToggle);
      if (label) label.textContent = expanded ? 'Less' : 'More';
      moreToggle.querySelector('.fb-toggle-arrow').classList.toggle('fb-toggle-arrow-up', expanded);
    });
  }

  /* ---------------- mobile drawers ---------------- */
  function setDrawer(name, open) {
    var backdrop = $('[data-drawer-backdrop="' + name + '"]');
    var drawer = $('[data-drawer="' + name + '"]');
    if (backdrop) backdrop.classList.toggle('open', open);
    if (drawer) drawer.classList.toggle('open', open);
  }

  function closeDrawers() {
    setDrawer('cat', false);
    setDrawer('filter', false);
    document.body.style.overflow = '';
  }

  $$('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeAllDropdowns();
      var name = btn.getAttribute('data-drawer-open');
      setDrawer(name, true);
      document.body.style.overflow = 'hidden';
    });
  });

  $$('[data-drawer-backdrop]').forEach(function (backdrop) {
    backdrop.addEventListener('click', closeDrawers);
  });

  $$('.pl-drawer a').forEach(function (link) {
    link.addEventListener('click', closeDrawers);
  });

  /* ---------------- contact now -> inquiry ---------------- */
  function bindCards(ctx) {
    $$('[data-card-inquiry]', ctx).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToInquiry({
          id: btn.getAttribute('data-id'),
          name: btn.getAttribute('data-name'),
          model: btn.getAttribute('data-model'),
          image: btn.getAttribute('data-image'),
          url: btn.getAttribute('data-url')
        });
      });
    });
  }
  bindCards(root);

  /* ---------------- mobile infinite scroll ---------------- */
  var sentinel = $('.pl-sentinel[data-next-url]');
  var grid = $('.pl-grid');
  var loadingEl = $('.pl-loading');
  var loading = false;

  function withPreview(url) {
    try {
      var u = new URL(url, window.location.origin);
      var current = new URL(window.location.href);
      var preview = current.searchParams.get('preview_theme_id');
      if (preview && !u.searchParams.get('preview_theme_id')) {
        u.searchParams.set('preview_theme_id', preview);
      }
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function loadMore() {
    if (loading || !sentinel || !grid) return;
    var nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) return;
    loading = true;
    if (loadingEl) loadingEl.hidden = false;

    fetch(withPreview(nextUrl), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cells = Array.prototype.slice.call(doc.querySelectorAll('.pl-grid .pl-cell'));
        cells.forEach(function (cell) {
          var node = document.importNode(cell, true);
          grid.appendChild(node);
          bindCards(node);
        });
        var nextSentinel = doc.querySelector('.pl-sentinel[data-next-url]');
        if (nextSentinel && cells.length) {
          sentinel.setAttribute('data-next-url', nextSentinel.getAttribute('data-next-url'));
        } else {
          sentinel.removeAttribute('data-next-url');
        }
      })
      .catch(function () {})
      .then(function () {
        loading = false;
        if (loadingEl) loadingEl.hidden = true;
      });
  }

  if (sentinel && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (window.innerWidth <= 1024 && entries[0].isIntersecting) loadMore();
    }, { rootMargin: '200px' });
    io.observe(sentinel);
  }
})();
